const IT = 'it-IT';

function splitIfNeeded(label: string): string {
  const trimmed = label.trim();
  if (!trimmed) return trimmed;

  // Se già contiene spazi, non tocchiamo
  if (trimmed.includes(' ')) return trimmed;

  // snake_case / SCREAMING_SNAKE_CASE
  if (trimmed.includes('_')) {
    return trimmed.replace(/_/g, ' ');
  }

  // PascalCase / camelCase con gestione acronimi (APIClient -> API Client)
  // 1) AAAa -> AA Aa
  // 2) aA -> a A
  return trimmed
    .replace(/([A-Z]+)([A-Z][a-zàèéìòóù])/g, '$1 $2')
    .replace(/([a-zàèéìòóù])([A-Z])/g, '$1 $2')
    .trim();
}

export function formatLabel(label: string): string {
  if (!label) return label;

  const formatted = splitIfNeeded(label);

  // Se vuoi che "Unknown (x)" resti identico, scommenta:
  // if (/^Unknown\s*\(/i.test(formatted)) return formatted;

  const lower = formatted.toLocaleLowerCase(IT);
  return lower.length > 0
    ? lower.charAt(0).toLocaleUpperCase(IT) + lower.slice(1)
    : lower;
}

export function formatLabelUpper(label: string): string {
  if (!label) return label;
  return splitIfNeeded(label).toLocaleUpperCase(IT);
}
